<script lang="ts">
  import { _ } from 'svelte-i18n';

  const t = (text: string) => {
    return $_(`messages.${text}`);
  };
</script>

<p>{t('complete_registration.title')}</p>
<p>{t('complete_registration.subtitle')}</p>

<style lang="scss">
  @use './styles.scss' as *;
</style>
